import { forwardRef } from "react";
import { space } from "styled-system";
import styled, { css } from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDivider = styled.div.withConfig({
  displayName: "divider__StyledDivider",
  componentId: "sc-1otbulw-0"
})(["margin:0;padding:0;line-height:1.5;font-size:", "px;color:", ";background:", ";", " ", " ", " ", " ", ""], p => p.theme.fontSizes.md, p => p.theme.colors.text, p => p.theme.colors.border.split, p => !p.children && css(["display:block;clear:both;width:100%;min-width:100%;height:1px;margin:", "px 0;"], p.theme.space.md), p => p.children && css(["display:table;margin:", "px 0;color:", ";font-size:", "px;font-weight:500;white-space:nowrap;text-align:center;background:transparent;&::before,&::after{display:table-cell;position:relative;top:50%;width:50%;transform:translateY(50%);border-top:", ";pointer-events:none;content:\"\";}", " ", ""], p.theme.space.sm, p.theme.colors.heading, p.theme.fontSizes.lg, p.theme.borders.split, p.align === "left" && css(["&::before{width:5%;}&::after{width:95%;}"]), p.align === "right" && css(["&::before{width:95%;}&::after{width:5%;}"])), p => p.dashed && css(["border-color:", ";border-style:dashed;border-width:1px 0 0;background:none;"], p.theme.colors.border.split), p => p.dashed && p.children && css(["border-top:0;&::before,&::after{border-style:dashed none none;}"]), space);
const InnerText = styled.span.withConfig({
  displayName: "divider__InnerText",
  componentId: "sc-1otbulw-1"
})(["display:inline-block;padding:0 1em;"]);
export const Divider = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    align = "center",
    dashed = false,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(StyledDivider, {
    ref: ref,
    ...rest,
    align: align,
    dashed: dashed,
    children: children && /*#__PURE__*/_jsx(InnerText, {
      children: children
    })
  });
});
export default Divider;